module.exports = __webpack_public_path__ + "media/images/common/ico-lp-ramen-cac04f9a41702d0e6e6cb0a9317a2d33.svg";